import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchSubscriberOverview (subscriberId, metricDate) {
  const body = {
    metric_date: metricDate
  }
  return utils.makeApiCall({
    url: `/api/insights/subscriber/overview/${subscriberId}`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW,
    actionReceive: ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW,
    actionFailure: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_FAILURE,
    authenticated: true,
    actionProps: {
      subscriberId: subscriberId,
      metricDate: metricDate
    }
  })
}

function fetchSubscriberGenreTitle (subscriberId, metricDate) {
  const body = {
    metric_date: metricDate
  }
  return utils.makeApiCall({
    url: `/api/insights/subscriber/genre/title/${subscriberId}`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE,
    actionReceive: ActionTypes.RECEIVE_SUBSCRIBER_GENRE_TITLE,
    actionFailure: ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE_FAILURE,
    authenticated: true,
    actionProps: {
      subscriberId: subscriberId,
      metricDate: metricDate
    }
  })
}

function fetchSubscriberWhatsNew (startDate, endDate, network) {
  const body = {
    start_date: startDate,
    end_date: endDate,
    network_label: network
  }
  return utils.makeApiCall({
    url: '/api/insights/calendar',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR,
    actionReceive: ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW_CALENDAR,
    actionFailure: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR_FAILURE,
    authenticated: true,
    actionProps: {
      network: network
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchSubscriberOverviewIfNeeded (subscriberId, metricDate) {
  return (dispatch, getState) => {
    const state = (getState().subscriber.byMetricDate[metricDate] || {}).overview
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSubscriberOverview(subscriberId, metricDate))
    }
    return Promise.resolve()
  }
}

export function fetchSubscriberGenreTitleIfNeeded (subscriberId, metricDate) {
  return (dispatch, getState) => {
    const state = (getState().subscriber.byMetricDate[metricDate] || {}).genreTitle
    //const state = (getState().subscriber.genreTitle || {})
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSubscriberGenreTitle(subscriberId, metricDate))
    }
    return Promise.resolve()
  }
}

export function fetchSubscriberWhatsNewIfNeeded (startDate, endDate, network) {
  return (dispatch, getState) => {
    const state = (getState().subscriber.byNetwork[network] || {}).whatsNew
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSubscriberWhatsNew(startDate, endDate, network))
    }
    return Promise.resolve()
  }
}

export function setSelectedNetwork (network) {
  return {
    type: ActionTypes.SUBSCRIBER_SELECTED_NETWORK,
    network
  }
}

export function setSelectedNetworkType (networkType) {
  return {
    type: ActionTypes.SUBSCRIBER_SELECTED_NETWORK_TYPE,
    networkType
  }
}

export function setCatalogSelectedMetricDateIfNeeded (metricDate) {
  return {
    type: ActionTypes.SUBSCRIBERS_SELECTED_QUARTER,
    metricDate
  }
}
